/**
 * Facets.ItemCell.View.Ext.js — Legacy module
 *
 * Adds brand, shortdescription, and upccode to the Facets.ItemCell.View context.
 * Must use _.wrap(getContext) because the base view's getContext() does NOT
 * expose 'model' in its context — addToViewContextDefinition can't access
 * the Backbone model's custom item fields.
 *
 * Self-executing: apply prototype mutation on define().
 */
define('Facets.ItemCell.View.Ext', [
    'Facets.ItemCell.View',
    'underscore'
], function(View, _) {
    'use strict';

    _.extend(View.prototype, {
        getContext: _.wrap(View.prototype.getContext, function extendContext(fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));

            return _.extend(context, {
                brand: this.model.get('custitem_cseg_brand'),
                shortdescription: this.model.get('storedescription'),
                upccode: this.model.get('upccode')
            });
        })
    });
});
